export default __webpack_public_path__ + "static/media/6.2d40adf5.jpg";